import styled from "styled-components/macro";

export const Label = styled.label`
  display: block;
  width: 100%;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #393839;
  margin-bottom: 7px;
`;
